export const JE_CONVERSION_RECENCY_MS = 15 * 60 * 1000;

export interface JeConversionMigrationTimestamps {
    accountsMappingFinalizedAt: Date | null;
    journalEntriesSyncedAt: Date | null;
    manualJournalEntriesConvertedAt: Date | null;
}

export function isJeConversionInProgress(
    migration: JeConversionMigrationTimestamps,
    nowMs: number = Date.now(),
): boolean {
    if (
        migration.accountsMappingFinalizedAt == null ||
        migration.journalEntriesSyncedAt == null ||
        migration.manualJournalEntriesConvertedAt != null
    ) {
        return false;
    }

    const conversionTriggeredAtMs = Math.max(
        migration.journalEntriesSyncedAt.getTime(),
        migration.accountsMappingFinalizedAt.getTime(),
    );
    return nowMs - conversionTriggeredAtMs < JE_CONVERSION_RECENCY_MS;
}
